/**
 * Formats a number as Swiss Franc currency
 * @param amount - The amount to format
 * @returns Formatted currency string (e.g., "CHF 850'000")
 */
export function formatCurrency(amount: number | null | undefined): string {
  if (amount == null || isNaN(amount)) {
    return 'N/A';
  }

  // Swiss formatting: CHF 1'234'567
  const formatted = amount.toFixed(0).replace(/\B(?=(\d{3})+(?!\d))/g, "'");

  return `CHF ${formatted}`;
}

/**
 * Formats a number as Swiss Franc currency in short format
 * @param amount - The amount to format
 * @returns Short formatted currency string (e.g., "CHF 850k" or "CHF 1.2M")
 */
export function formatCurrencyShort(amount: number | null | undefined): string {
  if (amount == null || isNaN(amount)) {
    return 'N/A';
  }

  if (amount >= 1_000_000) {
    return `CHF ${(amount / 1_000_000).toFixed(1)}M`;
  }

  if (amount >= 1_000) {
    return `CHF ${(amount / 1_000).toFixed(0)}k`;
  }

  return `CHF ${amount}`;
}
